export const getAllowedADTransitionsmachineNames = (ADRequest) => {
    return {
        "applied": ['approved', 'rejected'],
        "approved": !ADRequest.paymentDate? ['applied']: [],
        "part-settled":[],
        "settled": [],
        "rejected": ['applied'],
        "paid": [],
    }
};